import React from 'react'
import { useNavigate } from 'react-router-dom'
import { AddIcon, DeleteIcon, EditIcon, PrivateIcon, PublicIcon} from '../Assets/iconshere'
import Dropdown from 'react-bootstrap/Dropdown';
import Tooltip from "@mui/material/Tooltip";
import moment from 'moment';
import { useSelector } from 'react-redux';
import Skeleton from 'react-loading-skeleton';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import ConfirmBox from '../Components/ConfirmBox';




const EventsListCards = ({ setSideBar, list, search, loading, handleDeleteEvent, type, deleteItem, setDeleteItem, showDelete, setShowDelete }) => {
    var navigate = useNavigate();

    const userData = useSelector((state) => state.userSlice);

    const loadBox = 4;
    const tileCards = [];

    for (let i = 0; i < loadBox; i++) {
        tileCards.push(
            <div className='col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4 col-xxl-3  mb-4 '>
                <div className="eventbox" >
                    <div className='head pb-2'>
                        <p><Skeleton width="5vw" className='my-1' /> </p>
                    </div>
                    <div className='eventbody'>
                        <h1 className='mb-2' style={{ minHeight: "38px" }} ><Skeleton width="100%" height="100%" className='my-1' /> </h1>
                        <div className='maineventbody pb-2'>
                            <div className='start'>
                                <p><Skeleton width="3vw" className='my-1' /></p>
                                <h5><Skeleton width="5vw" className='my-1' /></h5>
                                <h6><Skeleton width="3vw" className='my-1' /></h6>
                            </div>
                            <div className='arrowhere'>
                                <hr />
                                <div className='redarrow'></div>
                            </div>
                            <div className='end'>
                                <p><Skeleton width="3vw" className='my-1' /></p>
                                <h5><Skeleton width="5vw" className='my-1' /></h5>
                                <h6><Skeleton width="3vw" className='my-1' /></h6>
                            </div>
                        </div>
                    </div>
                    <div className='eventfoot mt-2 pt-2'>
                        <Skeleton width="5vw" height={40} className='my-1' />
                    </div>
                </div>
            </div>)
    }

    const handleClickJoinEvent = (uuid) =>{
        navigate(`/invite/${uuid}`)
    }

    let filterList = list.filter((e) => e.name.toLowerCase().includes(search.toLowerCase()))

    return (
        <>
            {loading ?
                <>
                    {tileCards}
                </>
                :
                <>
                    {filterList.length > 0 ?
                        <>
                            {filterList.map((item, index) => {
                                return (
                                        <div key={item.uuid} className='col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4 col-xxl-3 mb-4 '>
                                            <div className={userData.user.uuid !== item.organizerId.uuid ? "eventbox sameuser" : "eventbox"}>
                                                <div className='head pb-2'>
                                                    <p>Event</p>
                                                    <div className='svgbtn'>
                                                        {item.type == "PRIVATE" ?
                                                            <PrivateIcon /> : <PublicIcon />
                                                        }
                                                        {item.type}
                                                    </div>
                                                </div>
                                                <div className='eventbody'>
                                                    <h1 className='mb-2' style={{ minHeight: "38px" }} >{item.name}</h1>
                                                    <div className='maineventbody pb-2'>
                                                        <div className='start'>
                                                            <p>Start</p>
                                                            <h5>{moment(item.startTime).format("DD/MM/YYYY")}</h5>
                                                            <h6>{moment(item.startTime).format("LT")}</h6>
                                                        </div>
                                                        <div className='arrowhere'>
                                                            <hr />
                                                            <div className='redarrow'></div>
                                                        </div>
                                                        <div className='end'>
                                                            <p>End</p>
                                                            <h5>{moment(item.endTime).format("DD/MM/YYYY")}</h5>
                                                            <h6>{moment(item.endTime).format("LT")}</h6>
                                                        </div>
                                                    </div>
                                                    <div className='invites'>
                                                        <div className='peeps'>
                                                            <AccessTimeIcon />
                                                            <p className='m-0'>Invitees : {item.users.length + item.guestEmails?.length}</p>
                                                        </div>

                                                        <Tooltip title={`Organised By : ${item.organizerId.name}`}>
                                                            <div className='peeps'>
                                                                {item.organizerId.avatar ?
                                                                    <img src={item.organizerId.avatar} alt={item.organizerId.name} className='peepimg' onError={(e) => { e.target.onerror = null; e.target.src = 'path_to_placeholder_image'; e.target.alt = 'Organizer' }} referrerPolicy={'no-referrer'}/>
                                                                    :
                                                                    <span className='peep-initialls p-2'>{item.organizerId.name.split(' ').map((word, index) => index === 0 || index === 1 ? word.charAt(0) : '').join('')}</span>
                                                                }
                                                            </div>
                                                        </Tooltip>
                                                    </div>
                                                </div>
                                                    {type === "expired" ? (
                                                        <>
                                                         <div className={userData.user.uuid !== item.organizerId.uuid ? "displaynone"  : 'eventfoot mt-2 pt-2' }>
                                                            {userData.user.uuid !== item.organizerId.uuid ? null:(
                                                                <>
                                                                <button
                                                                    disabled={userData.user.uuid !== item.organizerId.uuid}
                                                                    className="DefaultRedBtn secondary"
                                                                    style={{ padding: "5px 10px", fontSize: "13px" }}
                                                                    onClick={() => navigate(`/events/details/${item.uuid}`)}
                                                                >
                                                                    View Summary
                                                                </button>
                                                                   <div className='dropdown'>
                                                                   {
                                                                       userData.user.uuid === item.organizerId.uuid &&
                                                                       <Dropdown>
                                                                           <Dropdown.Toggle id="nested-dropdown">
                                                                               <div className="options">
                                                                                   <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-three-dots-vertical" viewBox="0 0 16 16">
                                                                                       <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z" />
                                                                                   </svg>
                                                                               </div>
                                                                           </Dropdown.Toggle>
                                                                           <Dropdown.Menu className="sidebartopbar modulelistoptions mets">
                                                                               <div className="listoptionsmodule">
                                                                                   {
                                                                                       type !== "expired" &&
                                                                                       <p onClick={() => navigate(`/events/${item.uuid}`)} >
                                                                                           <EditIcon />
                                                                                           Edit</p>
                                                                                   }
           
                                                                                   <p onClick={() => { setShowDelete(true); setDeleteItem(item.uuid) }}>
                                                                                       <DeleteIcon />
                                                                                       Delete</p>
                                                                               </div>
                                                                           </Dropdown.Menu>
                                                                       </Dropdown>
                                                                   }
                                                               </div>
                                                               </>
                                                            )}
                                                        </div>
                                                          </>
                                                    ) : (
                                                        <>
                                                        <div className='eventfoot mt-2 pt-2'>
                                                            <div className='d-flex align-items-center justify-content-start gap-2'>
                                                             { userData.user.uuid === item.organizerId.uuid  ?  <button
                                                                    className="DefaultRedBtn secondary"
                                                                    style={{ padding: "5px 10px", fontSize: "13px" }}
                                                                    onClick={() => navigate(`/events/details/${item.uuid}`)}
                                                                >
                                                                    View Summary
                                                                </button> : null}
                                                                <button
                                                                    className="DefaultRedBtn"
                                                                    style={{ padding: "5px 10px", fontSize: "13px" }}
                                                                    onClick={()=>{handleClickJoinEvent(item.shortId || item.uuid);setSideBar(true) }}
                                                                >
                                                            Join Event
                                                                </button>
                                                                </div>
                                                           <div className='dropdown'>
                                                           {
                                                               userData.user.uuid === item.organizerId.uuid &&
                                                               <Dropdown>
                                                                   <Dropdown.Toggle id="nested-dropdown">
                                                                       <div className="options">
                                                                           <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-three-dots-vertical" viewBox="0 0 16 16">
                                                                               <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z" />
                                                                           </svg>
                                                                       </div>
                                                                   </Dropdown.Toggle>
                                                                   <Dropdown.Menu className="sidebartopbar modulelistoptions mets">
                                                                       <div className="listoptionsmodule">
                                                                           {
                                                                               type !== "expired" &&
                                                                               <p onClick={() => navigate(`/events/${item.uuid}`)} >
                                                                                   <EditIcon />
                                                                                   Edit</p>
                                                                           }
   
                                                                           <p onClick={() => { setShowDelete(true); setDeleteItem(item.uuid) }}>
                                                                               <DeleteIcon />
                                                                               Delete</p>
                                                                       </div>
                                                                   </Dropdown.Menu>
                                                               </Dropdown>
                                                           }
                                                       </div>
                                                       </div>
                                                       </>
                                                    )}
                                           
                                            </div>
                                        </div>
                                )
                            })}
                        </>
                        :
                        <>
                            <div className='px-4'>
                            <div className="first-event">
                                No Events Found!
                                <button className='DefaultRedBtn' onClick={() => navigate(`/events/create`)}><AddIcon /> Create Event</button>
                            </div>
                            </div>
                        </>
                    }
                </>

            }

            <ConfirmBox title={"Delete Event"} message={"Do you really want to delete this Event?"} show={showDelete} handleSubmit={() => handleDeleteEvent(deleteItem)} handleClose={() => setShowDelete(false)} deleteBtn={true} />
        </>
    )
}
export default EventsListCards
